var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Spacer',[(_vm.data.title)?_c('Title',{attrs:{"data":{ value: _vm.data.title }}}):_vm._e(),_c('Grid',{attrs:{"col":_vm.gridCol,"row-gap":"m"}},_vm._l((_vm.data.items),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('Content',{attrs:{"data":_vm.content(item)}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }